module.exports = __webpack_public_path__ + "static/unidesporto-3a0afecce989e17e6a651eba2bcd922f.png";